import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { formatPrice } from '../../utils';
import countryContext from '../../context/country';
import './Price.module.css';

const Price = ({
  additionalText = null,
  children,
  price,
  isMinPrice,
  showVatMessage = true,
  ...props
}) => {
  const { t } = useTranslation();
  const { showExcludingVatPriceMessage } = useContext(countryContext);
  const { currency, language } = useSelector(state => ({
    language: state.i18n.language,
    currency: state.i18n.currency
  }));

  if (!price) {
    return null;
  }

  const formattedPrice =
    typeof price === 'number' ? formatPrice(price, language, currency) : price;

  return (
    <div {...props}>
      {isMinPrice
        ? t('Starting at {{price}}', {
            price: formattedPrice
          })
        : formattedPrice}
      {additionalText && <> {additionalText}</>}
      {children && <div>{children}</div>}
      {showExcludingVatPriceMessage && showVatMessage ? (
        <div styleName="vat">{t('excluding VAT')}</div>
      ) : null}
    </div>
  );
};

Price.defaultProps = {
  isMinPrice: false,
  price: null
};

export default Price;
